import MainRouteFallback from '@/components/MainRouteFallback'

function RouteSuspenseFallback() {
  return <MainRouteFallback />
}

export default RouteSuspenseFallback
